import React, { useCallback } from "react";
import { AutoComplete } from "antd";
import { AutoCompleteProps } from "antd/lib";
import { useLazyGetAddressListQuery } from "../../store/api/applicationBankApi/address.api";
import { useParams } from "react-router-dom";
import { debounce } from "lodash";

export const UI_ITOSelectAddressInput = ({
  onSelect,
  onChange,
  ...props
}: AutoCompleteProps) => {
  const { applicationId, applicationBankId } = useParams();
  const [searchAddress, { data }] = useLazyGetAddressListQuery();

  const options = data
    ? data.map((address) => ({
        label: address.fullName,
        value: address.fullName,
        info: address,
      }))
    : [];

  const debounceFn = (query: string) => {
    if (applicationBankId && applicationId) {
      searchAddress({
        applicationId: applicationId,
        applicationBankId: applicationBankId,
        queryValue: query,
      });
    }
  };

  const debouncedSearch = useCallback(debounce(debounceFn, 250), []);

  const onHandleChange: AutoCompleteProps["onChange"] = (value, option) => {
    debouncedSearch(value);
    if (onChange) onChange(value, option);
  };

  const onHandleSelect: AutoCompleteProps["onSelect"] = (value) => {
    const selectedOption = options.find((opt) => opt.value === value);

    if (selectedOption && onSelect) {
      onSelect(value, selectedOption);
    }
  };

  return (
    <AutoComplete
      {...props}
      onSelect={onHandleSelect}
      onChange={onHandleChange}
      options={options}
      allowClear
    />
  );
};
